import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import hubRunnerService from "services/hubRunnerService";

export const useListRunnerHub = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["order"]);
  const { addToast } = useToasts();

  const { hub_id, time_slot_id } = payload;

  return useQuery(
    ["hub-runner", hub_id, time_slot_id],
    () => hubRunnerService.listHubRunner(hub_id, time_slot_id),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("form.runner_id"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return data;
      },
    }
  );
};

// useGetRunnerCoordinationDefault
export const useGetRunnerCoordinationDefault = (
  payload,
  onSuccess,
  onError
) => {
  const {
    hub_id,
    time_slot_id,
    action_date,
    province_code,
    district_code,
    ward_code,
  } = payload;

  return useQuery(
    ["runner-coordination", hub_id, time_slot_id, action_date],
    () =>
      hubRunnerService.getRunnerCoordinationDefault(
        hub_id,
        time_slot_id,
        action_date,
        province_code,
        district_code,
        ward_code
      ),
    {
      enabled: false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data || null;
      },
    }
  );
};
